<template>
  <vonap-window
    :modal="true"
    :visible="value"
    :title="title"
    width="1200px"
    height="auto"
    @close="closeForm"
  >
    <v-layout>
      <v-container style="padding:0;">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-items>
            <div>
              <kendo-button
                icon="excel"
                title="Export to excel"
                @click="exportToExcel"
              ></kendo-button>
            </div>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout>
          <kendo-grid
            class="smallGrid"
            :dataSource="gridDataSource"
            :columns="columns"
            :filterable="true"
            :sortable="true"
            style="width:1169px;height:432px"
          ></kendo-grid>
        </v-layout>
        <v-divider></v-divider>
      </v-container>
    </v-layout>
  </vonap-window>
</template>

<script>
import {mapGetters} from 'vuex'
import VonapWindow from '@/components/VonapWindow'
import params from '@/helpers/params'

export default {
  name: 'TransactionListDetail',
  props: {
    value: {type: Boolean},
    asOfDate: {type: String, defaultValue: null},
    clientId: {type: Number, defaultValue: -1},
  },
  components: {
    VonapWindow,
  },
  mounted() {
    this.getData()
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),

    columns() {
      return [
        {
          title: 'Group Id',
          field: 'groupId',
          width: 50,
          attributes: {style: 'text-align:center'},
        },
        {
          title: 'Trade Id',
          field: 'number',
          width: 55,
          attributes: {style: 'text-align:center'},
        },
        {
          title: 'Description',
          field: 'description',
          width: 182,
          attributes: {style: 'text-align:left;'},
        },
        {
          title: 'Product',
          field: 'product',
          width: 60,
          attributes: {style: 'text-align:left;'},
        },
        {
          title: 'Leg',
          field: 'leg',
          width: 48,
          attributes: {style: 'text-align:left;'},
        },
        {
          title: 'Trade Date',
          field: 'tradeDate',
          attributes: {style: 'text-align:right'},
          width: 72,
          format: '{0:yyyy-MM-dd}',
        },
        {
          title: 'Maturity Date',
          field: 'maturity',
          attributes: {style: 'text-align:right'},
          width: 72,
          format: '{0:yyyy-MM-dd}',
        },
        {
          title: 'Buy / Sell',
          field: 'isBuying',
          width: 45,
          filterable: false,
          attributes: {style: 'text-align:left;'},
          template: '#=isBuying ? "Buy" : "Sell"#',
          footerTemplate: "<div style='text-align:right'>Total:</div>",
        },
        {
          title: 'Quantity Com.Ccy',
          field: 'quantity',
          attributes: {style: 'text-align:right'},
          width: 78,
          format: '{0:N0}',
          aggregates: ['sum'],
          footerTemplate:
            "<div style='text-align:right'>#=kendo.toString(data.quantity.sum, 'n0') # </div>",
        },
        {
          title: 'Com.Ccy',
          field: 'foreignCcy',
          width: 55,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Hedge Rate',
          field: 'hedgeRate',
          attributes: {style: 'text-align:right'},
          width: 55,
          format: '{0:N4}',
        },
        {
          title: 'Buy / Sell',
          field: 'isBuying',
          width: 45,
          filterable: false,
          attributes: {style: 'text-align:left;'},
          template: '#=isBuying ? "Sell" : "Buy"#',
        },
        {
          title: 'Quantity Ccy2',
          field: 'quantity2',
          attributes: {style: 'text-align:right'},
          width: 78,
          format: '{0:N0}',
        },
        {
          title: 'Ccy2',
          field: 'baseCcy',
          width: 52,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Saving FINMETRIX',
          field: 'savingFinmetrix',
          attributes: {style: 'text-align:right'},
          width: 78,
          format: '{0:N2}',
        },
        {
          title: 'Others / Premium',
          field: 'otherReference',
          width: 61,
        },
        {
          title: 'Reference Premium Ccy',
          field: 'reference',
          width: 61,
        },
        {},
      ].filter(c => c.editable !== false)
    },
  },
  data() {
    return {
      title: '',
      gridDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: false,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/SendingMessage/transactionListDetail',
            data: () => ({asOfDate: this.asOfDate, clientId: this.clientId}),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'clientId',
            fields: {
              clientId: {type: 'number'},
              clientName: {type: 'string'},
              groupId: {type: 'number'},
              number: {type: 'string'},
              description: {type: 'string'},
              product: {type: 'string'},
              leg: {type: 'string'},
              tradeDate: {type: 'date'},
              maturity: {type: 'date'},
              isBuying: {type: 'boolean'},
              quantity: {type: 'number'},
              foreignCcy: {type: 'string'},
              hedgeRate: {type: 'number'},
              quantity2: {type: 'number'},
              baseCcy: {type: 'string'},
              savingFinmetrix: {type: 'number'},
              otherReference: {type: 'string'},
              reference: {type: 'string'},
            },
          },
        },
        aggregate: [{field: 'quantity', aggregate: 'sum'}],
      }),
    }
  },
  methods: {
    async getData() {
      this.title = 'Transaction list'
      setTimeout(async () => {
        await this.gridDataSource.read()
      }, 100)
    },
    exportToExcel() {
      const exportUrl = '/api/report/SendingMessage/exportTransactionListDetail'
      const qs = params.fromObject({
        asOfDate: this.asOfDate,
        clientId: this.clientId,
        t: this.tokenString,
      })
      location.href = `${exportUrl}?${qs}`
    },
    closeForm() {
      this.$emit('input', false)
    },
  },
  watch: {
    asOfDate(newVal) {
      if (newVal) {
        this.getData()
      }
    },
  },
}
</script>

<style>
.smallGrid {
  font-size: 9px !important;
}
.smallGrid .k-grid-header .k-header {
  font-size: 9px !important;
}
.smallGrid .k-grid-header .k-header > .k-link {
  padding: 4px !important;
}
.smallGrid .k-grid-filter {
  padding: 0 !important;
  margin: 0 !important;
  width: 10px;
  height: 10px;
}
</style>
